import React from 'react';

export function numeroOS(valor) {
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
  let texto = String(valor ?? '').trim().replace(/R\$/gi, '').replace(/\s/g, '');
  if (texto.includes(',')) texto = texto.replace(/\./g, '').replace(',', '.');
  const numero = Number(texto);
  return Number.isFinite(numero) ? numero : 0;
}

export const subtotalOS = item => Math.round(numeroOS(item.valor) * numeroOS(item.qtd) * 100) / 100;

export function calcularTotaisOS(lancamentos = [], insumos = []) {
  const centavos = {servicos:0, produtos:0, outros:0, insumos:0, auxiliares:0};
  let auxiliaresInformados = true;
  lancamentos.forEach(item => {
    if (['excluido','cancelado'].includes(String(item.status || '').toLowerCase())) return;
    const tipo = Number(item.tipo || 0);
    const campo = tipo === 0 ? 'servicos' : tipo === 1 ? 'produtos' : 'outros';
    centavos[campo] += Math.round(subtotalOS(item) * 100);
    const nomeAuxiliar = String(item.auxiliar_flex || '').trim();
    const temAuxiliar = Number(item.auxiliar_flex_id || 0) > 0 || (nomeAuxiliar && !['-','—'].includes(nomeAuxiliar));
    if (tipo === 0 && temAuxiliar) {
      if (item.auxiliar_flex_custo === undefined || item.auxiliar_flex_custo === null || item.auxiliar_flex_custo === '') auxiliaresInformados = false;
      else centavos.auxiliares += Math.round(numeroOS(item.auxiliar_flex_custo) * 100);
    }
  });
  insumos.forEach(item => {
    if (['excluido','cancelado'].includes(String(item.status || '').toLowerCase())) return;
    centavos.insumos += Math.round(subtotalOS(item) * 100);
  });
  return {servicos:centavos.servicos/100, produtos:centavos.produtos/100,
    outros:centavos.outros/100, insumos:centavos.insumos/100,
    auxiliares:auxiliaresInformados ? centavos.auxiliares/100 : null,
    os:(centavos.servicos+centavos.produtos+centavos.outros)/100};
}

export default function ResumoTotaisOS({totais}) {
  const moeda = valor => valor === null ? 'Não informado' : valor.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
  const itens = [['Serviços',totais.servicos],['Produtos',totais.produtos]];
  if (totais.outros !== 0) itens.push(['Outros lançamentos',totais.outros]);
  itens.push(['Insumos (custo)',totais.insumos],['Auxiliares (custos)',totais.auxiliares],['Total da OS',totais.os]);
  return <div aria-label="Totais da OS" style={{display:'flex',flexWrap:'wrap',gap:8,margin:'12px 0'}}>
    {itens.map(([rotulo,valor])=><div key={rotulo} style={{flex:'1 1 160px',border:'1px solid #dee2e6',borderRadius:4,padding:'8px 12px',background:rotulo==='Total da OS'?'#e8f6f8':'#f8f9fa'}}>
      <div>{rotulo}</div><strong>{moeda(valor)}</strong>
    </div>)}
  </div>;
}
